
import React from 'react';

import Graphics from './Content/Graphics';
import InfoText from './Content/InfoText';
import PriceButton from './Content/PriceButton';

const MobileQuarterly = () => {
	return (
		<>
			<Graphics.Down10 />
			<PriceButton center>
				1 scan / quarter, paid quarterly
			</PriceButton>
			<PriceButton center>
				2 scans / quarter, paid quarterly
			</PriceButton>
			<InfoText.NoStrings />
		</>
	);
};

export default MobileQuarterly;
